
/*!
 * Taille du visuel sur la home en full screen.
 */
 if ($(".common .container-visuel")) {
 	$(".common .container-visuel").css("height", $(window).height()-$("header .container").height());

 	$(window).on("resize", function () {
 		$(".common .container-visuel").css("height", $(window).height()-$("header .container").height());
 	});
 }


// Temporary popup
var compare_dates = function(date1,date2){
	var today = new Date(); 
	if (date1<today) {
		if (date2>today) {
			return true;
		} else {
			return false;
		}
	} else {
		return false;
	}
}
if (compare_dates(new Date('02/11/2021 09:00'), new Date('02/28/2021 17:00')) == true) {
	$('.popup-container').addClass('showIt');
} else {
	$('.popup-container').remove();
}



if ($('.popup-container').length > 0) {
	$('.popup-close').click(function() {
		$('.popup-container').remove();
	})
}
